// Frozen in at build time from package.json by Vite's `define` (see
// vite.config.ts). The server reads the same value from its own package.json;
// VersionRepository polls one against the other to prompt a reload after a
// deploy.
declare const __APP_VERSION__: string

export const APP_VERSION: string = typeof __APP_VERSION__ === 'string' ? __APP_VERSION__ : '0.0.0'
